import styled, { css } from 'styled-components';
import PasswordShow from '../../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-password-show.svg'
import PasswordHide from '../../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-password-hide.svg'
import { colour , spacing, media, TextParagraph } from '../../../theme';
import colors from '../../../theme/variables/colors';

export const StepIndicatorContainer = styled.div`
  width: 100%;
  margin-bottom: 2.5rem;
`;

export const StepIndicatorBtnContainer = styled.div<{
  withbackbtn: true | false;
}>`
  ${(props) =>
    props.withbackbtn === true &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      column-gap: ${spacing.spacing5};
      row-gap: ${spacing.spacing3};

      @media only screen and (max-width: 600px) {
        column-gap: 0;
        align-items: flex-start;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: flex-start;
        row-gap: ${spacing.spacing1};

        .step-indicator-right-actions {
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          margin-left: 0;
          width: 100%;
          flex: 1 1 100%;
        }

        .step-indicator-right-actions > * {
          margin-left: 0;
          padding-left: 0;
        }

        .step-indicator-right-actions a,
        .step-indicator-right-actions button {
          margin: 0;
          padding-left: 0;
          white-space: normal;
          max-width: 100%;
        }

        .step-indicator-step {
          flex-basis: 100%;
          width: 100%;
          text-align: left;
          margin: 0;
          padding: 0;

          > div {
            text-align: left;
            margin: 0;
            padding: 0;
          }
        }
      }

      // Galaxy fold
      @media screen and (max-width: 293px) {
        flex-direction: column;
      }
    `};

  ${(props) =>
    props.withbackbtn === false &&
    css`
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: wrap;
      gap: ${spacing.spacing3};
    `};
`;
export const StepIndicatorSpan = styled.span`
  margin: 1.125rem 0;
  font-size: 1.25rem;
  letter-spacing: 0.0313rem;
  line-height: 1.5;
  font-weight: 700;
  font-family: 'Raleway', 'Open Sans', 'Helvetica Neue', Helvetica, Arial,
    sans-serif;

  @media ${media.small} {
    margin: 1rem 0;
    font-size: 1.5rem;
    letter-spacing: 0.03rem;
    line-height: 1.5;
  }

  @media only screen and (max-width: 600px) {
    margin: 0;
    font-size: 1rem;
    white-space: normal;
    word-break: break-word;
    max-width: 100%;
    display: block;
  }
`;

export const StepIndicatorColumn = styled.div<{ align?: 'left' | 'right' }>`
  display: flex;
  flex: 1 1 320px;
  min-width: 240px;
  gap: ${spacing.spacing2};
  justify-content: ${(props) =>
    props.align === 'right' ? 'flex-end' : 'flex-start'};
  flex-wrap: wrap;
  align-items: center;

  @media only screen and (max-width: 600px) {
    flex: 1 1 100%;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0;

    ${(props) =>
      props.align === 'right' &&
      css`
        justify-content: flex-start;
        align-items: flex-start;
        flex: 1 1 100%;
        width: 100%;
        margin-top: ${spacing.spacing2};
      `}
  }
`;

export const HorizontalRule = styled.hr`
  padding: 0;
  margin: 0;
  border-style: none;
  border-bottom: 4px solid ${colour.hrBorder};
`;

export const VisuallyHiddenText = styled.span`
  border: none;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;
export const StyledNumberShow = styled(PasswordShow)`
    margin-right: ${spacing.spacing2};
    path {
        fill: ${colors.darkBtnBG};
    }
`;
export const StyledNumberHide = styled(PasswordHide)`
    margin-right: ${spacing.spacing2};
    path {
        fill: ${colors.darkBtnBG};
    }
`;

export const StyledTextParagraph = styled(TextParagraph)`
    margin-top: ${spacing.spacing5};
    @media ${media.small} {
        margin-top: ${spacing.spacing7};
    }
`;

export const StyledBackLink = styled.a`
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  gap: ${spacing.spacing0};
  font-size: 1rem;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: calc(1.55556);
  margin: 1rem 0;
  padding: calc(0.625rem) 0;
  min-width: 3rem;
  cursor: pointer;
  background-color: transparent;
  color: rgb(0, 102, 204);
  text-decoration: underline;
  font-weight: 600;
  text-decoration-color: rgb(0, 102, 204);
  white-space: nowrap;
  
  &:hover {
    background-color: #f0f0f0;
  }

  svg {
    display: block;
    flex-shrink: 0;
    margin-right: ${spacing.spacing1};
    width: 0.9rem;
    height: 0.9rem;
  }

  @media ${media.small} {
    font-size: 1.15rem;
  }

  @media only screen and (max-width: 600px) {
    white-space: normal;
    flex-wrap: nowrap;
    text-align: left;
    align-items: center;
    margin: 0;
    padding: 0;
    width: auto;
    max-width: 100%;
    gap: ${spacing.spacing1};

    svg {
      margin-right: ${spacing.spacing1};
      width: 0.8rem;
      height: 0.8rem;
    }
  }
`;

export const StyledText = styled(TextParagraph)`
  margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing3} ${spacing.spacing0};
  word-break: break-all;
  overflow-wrap: break-word;
  @media only screen and (max-width : 500px) {
    max-width: 80% !important;
  }
`;

export const StyledTextEllipsis = styled(TextParagraph)`
  margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing3} ${spacing.spacing0};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media only screen and (max-width : 500px) {
    max-width: 80% !important;
  }
`;

export const StyledTextTruncate = styled(TextParagraph)`
  margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing3} ${spacing.spacing0};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  @media only screen and (max-width : 500px) {
    max-width: 80% !important;
  }
`;

export const StyledTextWordWrap = styled(TextParagraph)`
  margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing3} ${spacing.spacing0};
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-all;
  @media only screen and (max-width : 500px) {
    max-width: 80% !important;
  }
`;

export default StyledText;
